import { TemplateResult, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import encapsulatedStyles from './styles/outline-ratings-layout.inner.pcss?inline';
import globalStyles from './styles/outline-ratings-layout.global.pcss?inline';

/**
 * The OutlineRatingsLayout component
 * @element outline-ratings-layout
 */
@customElement('outline-ratings-layout')
export class OutlineRatingsLayout extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    encapsulatedCSS: encapsulatedStyles,
    globalCSS: globalStyles,
  });

  render(): TemplateResult {
    return html`
      <div class="outline-ratings-layout">
        <div class="heading">
          <slot name="heading"></slot>
        </div>
        <div class="row-two-column">
          <div class="summary">
            <slot name="summary"></slot>
          </div>
          <div class="breakdown">
            <slot name="breakdown"></slot>
          </div>
        </div>
        <div class="comments">
          <slot name="comments"></slot>
        </div>

        <div class="ratings-disclaimer">
          <slot name="disclaimer-heading"></slot>

          <div class="disclaimer-text">
            <slot name="disclaimer-text"></slot>
          </div>
        </div>
      </div>
    `;
  }
}

// Declare the custom element for TypeScript
declare global {
  interface HTMLElementTagNameMap {
    'outline-ratings-layout': OutlineRatingsLayout;
  }
}
